import type React from 'react';
import { memo } from 'react';

import Divider from '../../../Divider';

export interface DropdownFooterProps {
  children: React.ReactNode;
}

const DropdownFooter = ({ children }: DropdownFooterProps) => (
  <div className='flex flex-col gap-2.5'>
    <Divider />
    {children}
  </div>
);

export default memo(DropdownFooter);
